import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {AgendaEventFieldsSchema} from '@/features/agenda/formSchemas'
import {generateRepetitionOptions} from '@/features/agenda/utils'
import {useTranslation} from '@/translations/i18n'
import {useFormContext, useWatch} from 'react-hook-form'
import {z} from 'zod'
import {StyledAgendaEventRepeatSchedule} from '@/features/agenda/components/agenda-event-form/agenda-event-repeat-schedule-fields/style'
import {Text} from '@/components/ui/text/Text'
import {AgendaRepeatScheduleSwitchField} from '@/features/agenda/components/agenda-event-form/agenda-repeat-schedule-switch-field/AgendaRepeatScheduleSwitchField'
import {AgendaRepeatScheduleSelectField} from '@/features/agenda/components/agenda-event-form/agenda-repeat-schedule-select-field/AgendaRepeatScheduleSelectField'

const AgendaEventRepeatScheduleSchema = AgendaEventFieldsSchema.pick({
    consultants: true,
    date: true,
    patients: true,
    isRepeated: true,
    repetitionData: true
})
type AgendaEventRepeatScheduleSchema = z.infer<typeof AgendaEventRepeatScheduleSchema>

export const AgendaEventRepeatScheduleFields = () => {
    const {t} = useTranslation()
    const {control} = useFormContext<AgendaEventRepeatScheduleSchema>()

    // Form values
    const date = useWatch({control, name: 'date'})
    const isRepeated = useWatch({control, name: 'isRepeated'})
    const repetitionOptions = date?.date && generateRepetitionOptions(date.date, t)

    return (
        <Flexbox direction="column" gap={4}>
            <StyledAgendaEventRepeatSchedule fullWidth justify="space-between">
                <Flexbox gap={2} align="center">
                    <AgendaRepeatScheduleSwitchField />
                    {isRepeated && repetitionOptions && (
                        <>
                            <AgendaRepeatScheduleSelectField />
                            <Text size="textSm">{t('agenda:repeat_for_project_duration')}</Text>
                        </>
                    )}
                </Flexbox>
            </StyledAgendaEventRepeatSchedule>
        </Flexbox>
    )
}
